import React from "react";
import { Show, DateInput, TextInput, SimpleShowLayout } from "react-admin";

export const CultureMediaShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextInput source="code" />
        <TextInput source="culture_medium" />
        <DateInput label="Created at" source="created_at" />
        <DateInput source="updated_at" />
      </SimpleShowLayout>
    </Show>
  );
};
